import React from "react";
import styles from "../../../pages/styles";
import { technologyimage } from "../../../assets/images";
import { Users, Globe, Clock, Video, Brain, Sparkles } from "lucide-react";

const OurApproach = () => {
  return (
    <section id="ourapproach" className="py-8 md:py-10 px-4 md:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-4xl mx-auto mb-6 md:mb-8">
          <h2 className={`${styles.biggerheadingdark} mb-3 md:mb-4`}>
            Our Approach
          </h2>
          <p className={`${styles.paragraph}`}>
            Teaching with technology to spark curiosity and make learning fun
          </p>
        </div>
        <div className="flex flex-col md:flex-row items-start gap-8 md:gap-12">
          <div className="flex-1">
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Users className="w-5 h-5 text-darkprimary mt-0.5 flex-shrink-0" />
                <span className={`${styles.paragraph} text-sm`}>Dedicated expert instructors</span>
              </li>
              <li className="flex items-start gap-3">
                <Globe className="w-5 h-5 text-darkprimary mt-0.5 flex-shrink-0" />
                <span className={`${styles.paragraph} text-sm`}>Inclusive tech education for kids of all abilities</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-darkprimary mt-0.5 flex-shrink-0" />
                <span className={`${styles.paragraph} text-sm`}>Flexible scheduling for busy families</span>
              </li>
              <li className="flex items-start gap-3">
                <Video className="w-5 h-5 text-darkprimary mt-0.5 flex-shrink-0" />
                <span className={`${styles.paragraph} text-sm`}>Interactive virtual classes</span>
              </li>
              <li className="flex items-start gap-3">
                <Brain className="w-5 h-5 text-darkprimary mt-0.5 flex-shrink-0" />
                <span className={`${styles.paragraph} text-sm`}>STEAM learning and social skills</span>
              </li>
              <li className="flex items-start gap-3">
                <Sparkles className="w-5 h-5 text-darkprimary mt-0.5 flex-shrink-0" />
                <span className={`${styles.paragraph} text-sm`}>Fun, hands on learning with every session</span>
              </li>
            </ul>
          </div>
          <div className="flex-1 flex justify-center">
            <img
              src={technologyimage}
              alt="Technology"
              className="w-full max-w-[300px] rounded-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurApproach;
